module.exports = __webpack_public_path__ + "media/images/current-location-active-5123efd697319c50660d2486d6903df0.png";